import React, { useState } from "react";

import { IconContext } from "react-icons";
import { CiMail } from "react-icons/ci";
import { CiLocationOn } from "react-icons/ci";

import { ThreeDots } from "react-loading-icons";

import styles from "./Contact.module.css";
import { sendEmail } from "../../components/emailJS/EmailJS";

export default function ContactSection() {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const response = await sendEmail(formData);
    setMessage(response);
    setIsLoading(false);
  };

  return (
    <div className={styles.contactSection}>
      <div className={styles.contactContainer}>
        {/* Contact Information Column */}
        <div className={styles.infoColumn}>
          <h2 className={styles.columnTitle}>Contact Information</h2>

          {/* Email Info Card */}
          <div className={styles.infoCard}>
            <IconContext.Provider value={{ size: "10%" }}>
              <CiMail />
            </IconContext.Provider>

            <h3 className={styles.infoLabel}>Email</h3>
            <p className={styles.infoText}>msroadworkersfoundation@gmail.com</p>
          </div>

          {/* Address Info Card */}
          <div className={styles.infoCard}>
            <IconContext.Provider value={{ size: "10%" }}>
              <CiLocationOn />
            </IconContext.Provider>

            <h3 className={styles.infoLabel}>Address</h3>
            <p className={styles.infoText}>
              PO Box 1345
              <br />
              Jackson, MS 39215
            </p>
          </div>
        </div>

        {/* Message Form Column */}
        <div className={styles.messageColumn}>
          <h2 className={styles.columnTitle}>Send Us a Message</h2>

          <form className={styles.contactForm} onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={styles.formInput}
              />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="phoneNumber">Phone Number</label>
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleChange}
                className={styles.formInput}
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                className={styles.formInput}
              />
            </div>

            <div className={styles.formGroup}>
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className={styles.formTextArea}
                rows="4"
              />
            </div>

            <button
              type="submit"
              className={styles.submitButton}
              onClick={handleSubmit}
            >
              {isLoading ? <ThreeDots width="30%" /> : "Send Message"}
            </button>
            <p>{message}</p>
          </form>
        </div>
      </div>
    </div>
  );
}
